module.exports = __webpack_public_path__ + "img/ss.99492e15.png";